export const DOWNLOAD_MESSAGES = {
  NO_DICOM_AVAILABLE: 'No DICOM images are available to download for this study.',
  NO_JPEG_AVAILABLE: 'No images are available for JPEG export in this study.',
  NO_JPEG_SELECTED: 'Select one or more images before downloading JPEG.',
  DOWNLOAD_FAILED: 'The download could not be completed. Please try again.',
  JPEG_CONVERSION_FAILED:
    'Images could not be converted to JPEG. The viewport may be empty or the image format is unsupported.',
  JPEG_DOWNLOAD_FAILED: 'The JPEG download could not be completed. Please try again.',
  ZIP_GENERATION_FAILED:
    'The ZIP file could not be created. Try downloading fewer images or use a different browser.',
  BROWSER_UNSUPPORTED:
    'Your browser does not support file downloads from the viewer. Please use a recent version of Chrome, Firefox, or Safari.',
  EXPORT_IN_PROGRESS: 'A download is already in progress. Please wait for it to finish.',
  PREPARING_ZIP: 'Preparing DICOM ZIP…',
  PREPARING_JPEG: 'Preparing JPEG export…',
  DICOM_EXPORT_SUCCESS: (filename: string) => `Your DICOM archive "${filename}" is downloading.`,
  JPEG_EXPORT_SUCCESS: (filename: string, countSuffix = '') =>
    `Your JPEG file "${filename}"${countSuffix} is downloading.`,
} as const;

export function formatExportProgress(completed: number, total: number, label: string): string {
  if (!total) {
    return label;
  }

  return `${label} (${completed}/${total})…`;
}
